module.exports = __webpack_public_path__ + "img/manufacturing_jinhai.788647cb.png";